const HR_SERVICE_MANAGEMENT_TYPES = [{
  label: 'Employee Onboarding',
  value: 1,
  key: 1,
  icon: 'EpicFilled', // Major lifecycle event
  color: '#1976d2',
  background: 'rgba(144,202,249,0.16)'
}, {
  label: 'Employee Offboarding',
  value: 2,
  key: 2,
  icon: 'BugFilled', // Critical state change
  color: '#c62828',
  background: 'rgba(255,171,145,0.16)'
}, {
  label: 'Leave Management',
  value: 3,
  key: 3,
  icon: 'TaskFilled', // Repetitive process
  color: '#7cb342',
  background: 'rgba(220,237,200,0.16)'
}, {
  label: 'Attendance Tracking',
  value: 4,
  key: 4,
  icon: 'StoryFilled', // Ongoing timeline-based
  color: '#f9a825',
  background: 'rgba(255,241,118,0.16)'
}, {
  label: 'Employee Helpdesk',
  value: 5,
  key: 5,
  icon: 'SupportFilled',
  color: '#00897b',
  background: 'rgba(178,223,219,0.16)'
}, {
  label: 'HR Policy Queries',
  value: 6,
  key: 6,
  icon: 'FeatureRequestFilled', // Close to asking or requesting info
  color: '#6a1b9a',
  background: 'rgba(209,196,233,0.16)'
}];

const RECRUITMENT_TYPES = [{
  label: 'Job Requisition',
  value: 1,
  key: 1,
  icon: 'ChangerequestFilled',
  color: '#283593',
  background: 'rgba(197,202,233,0.16)'
}, {
  label: 'Job Posting',
  value: 2,
  key: 2,
  icon: 'FeatureRequestFilled',
  color: '#0288d1',
  background: 'rgba(144,202,249,0.16)'
}, {
  label: 'Resume Screening',
  value: 3,
  key: 3,
  icon: 'SubtaskFilled',
  color: '#2e7d32',
  background: 'rgba(165,214,167,0.16)'
}, {
  label: 'Interview Scheduling',
  value: 4,
  key: 4,
  icon: 'TaskFilled',
  color: '#ef6c00',
  background: 'rgba(255,224,178,0.16)'
}, {
  label: 'Candidate Evaluation',
  value: 5,
  key: 5,
  icon: 'ImprovementsFilled',
  color: '#5e35b1',
  background: 'rgba(209,196,233,0.16)'
}, {
  label: 'Offer Management',
  value: 6,
  key: 6,
  icon: 'StoryFilled', // Progression/story for the candidate
  color: '#00695c',
  background: 'rgba(178,223,219,0.16)'
}];
const POLICY_MANAGEMENT_TYPES = [{
  label: 'Policy Creation',
  value: 1,
  key: 1,
  icon: 'EpicFilled',
  color: '#1976d2',
  background: 'rgba(144,202,249,0.16)'
}, {
  label: 'Policy Review',
  value: 2,
  key: 2,
  icon: 'TaskFilled',
  color: '#0288d1',
  background: 'rgba(144,202,249,0.16)'
}, {
  label: 'Policy Update',
  value: 3,
  key: 3,
  icon: 'ImprovementsFilled',
  color: '#f9a825',
  background: 'rgba(255,241,118,0.16)'
}, {
  label: 'Compliance Enforcement',
  value: 4,
  key: 4,
  icon: 'BugFilled',
  color: '#c62828',
  background: 'rgba(255,171,145,0.16)'
}];

const PERFORMANCE_REVIEW_TYPES = [{
  label: 'Self Evaluation',
  value: 1,
  key: 1,
  icon: 'FeatureRequestFilled', // Self-submitted input
  color: '#2e7d32',
  background: 'rgba(200,230,201,0.16)'
}, {
  label: 'Manager Review',
  value: 2,
  key: 2,
  icon: 'StoryFilled', // Manager narrative/judgment
  color: '#283593',
  background: 'rgba(197,202,233,0.16)'
}, {
  label: '360 Feedback',
  value: 3,
  key: 3,
  icon: 'SupportFilled', // Peer input
  color: '#0288d1',
  background: 'rgba(144,202,249,0.16)'
}, {
  label: 'Performance Appraisal',
  value: 4,
  key: 4,
  icon: 'TaskFilled',
  color: '#f57c00',
  background: 'rgba(255,224,178,0.16)'
}, {
  label: 'Goal Tracking',
  value: 5,
  key: 5,
  icon: 'SubtaskFilled',
  color: '#7cb342',
  background: 'rgba(220,237,200,0.16)'
}];

export {
  HR_SERVICE_MANAGEMENT_TYPES,
  RECRUITMENT_TYPES,
  POLICY_MANAGEMENT_TYPES,
  PERFORMANCE_REVIEW_TYPES
};
